import React, { useState, useEffect } from "react";
import { baseurl } from "../../api";
import './Navbar.css';
import MyProfile from '../Popup/MyProfile/MyProfile';
import NotificationPopup from '../Popup/NotificationMainPopup/NotificationMainPopup';
import apiClient from "../../api";
import axios from 'axios';

function Navbar() {
  const [showProfileOptions, setShowProfileOptions] = useState(false);
  const [showNotificationOptions, setShowNotificationOptions] = useState(false);
  const [unseenNotificationCount, setUnseenNotificationCount] = useState(0);

  const [userData, setUserData] = useState(null);
  const [languages, setLanguages] = useState([]);
  // console.log(userData?.country_flag ? `${baseurl}${userData.country_flag}` : '/assets/India.png');
  // console.log(userData?.profile_pic ? `${baseurl}${userData.profile_pic}` : '/assets/avatar.jpg');
  
  const toggleProfileOptions = () => {
    setShowProfileOptions((prev) => !prev);
  };

  // const toggleNotificationPopup = () => {
  //   setShowNotificationOptions((prev) => !prev);
  // };
  const toggleNotificationPopup = () => {
    setShowNotificationOptions((prev) => !prev);
    
    if (!showNotificationOptions) {
      // Mark all notifications as seen
      markNotificationsAsSeen();
    }
  };
  // Function to mark notifications as seen
const markNotificationsAsSeen = async () => {
  try {
    await axios.post(`${baseurl}SuperAdminNotifications/mark-seen/`);
    // Fetch the updated count of unseen notifications
    fetchUnseenNotificationCount();
  } catch (error) {
    console.error("Error marking notifications as seen:", error);
  }
};

  useEffect(() => {
    const token = localStorage.getItem('accessToken'); // Get the correct token
  
    if (token) {
      // Fetch user details
      apiClient.get('accounts/personal-user/profile/', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          setUserData(response.data.data);
        })
        .catch((error) => console.error('Error fetching user details:', error));
  
      // Fetch all languages
      apiClient.get('localization/languages/', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          // Use response.data.data instead of response.data.languages
          setLanguages(response.data.data || []);
        })
        .catch((error) => console.error('Error fetching languages:', error));
    } else {
      console.error('Authentication token not found.');
    }
  }, []);
  const fetchUnseenNotificationCount = async () => {
    try {
      const response = await axios.get(`${baseurl}SuperAdminNotifications/unseen-count/`);
      setUnseenNotificationCount(response.data.count);
    } catch (error) {
      console.error("Error fetching unseen notification count:", error);
    }
  };
  
  useEffect(() => {
    fetchUnseenNotificationCount();
  }, []);
  

  return (
    <div className="navbar">
      <div className="sub_navbar">
        <div className="logo-container">
          <img src="/assets/logo1.png" alt="logo" className="logo" />
        </div>
        <div className="user-section">

          <div onClick={toggleNotificationPopup} className="notifications cr-pointer">
  {unseenNotificationCount > 0 && (
    <span className="badge-red">{unseenNotificationCount}</span>
  )}
  <svg className="bell-icon" width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18 17V18H0V17L2 15V9C2 5.9 4.03 3.17 7 2.29V2C7 1.46957 7.21071 0.960859 7.58579 0.585786C7.96086 0.210714 8.46957 0 9 0C9.53043 0 10.0391 0.210714 10.4142 0.585786C10.7893 0.960859 11 1.46957 11 2V2.29C13.97 3.17 16 5.9 16 9V15L18 17ZM11 19C11 19.5304 10.7893 20.0391 10.4142 20.4142C10.0391 20.7893 9.53043 21 9 21C8.46957 21 7.96086 20.7893 7.58579 20.4142C7.21071 20.0391 7 19.5304 7 19" fill="white" />

  </svg>
</div>

          <div className="country-nav">
            <img 
              src={userData?.country_flag ? `${baseurl}${userData.country_flag.replace(/^\//, '')}` : '/assets/India.png'} 
              alt="user profile" 
              className="country-image" 
            />
            <select id="countrySelect" className="countries-name common-text fts-13 ftw-4 white" >
              {languages.map((language) => (
                <option key={language.id} value={language.id}>
                  {language.name}
                </option>
              ))}
            </select>
          </div>
          <div className="user-info">
            <div className="user-image-container" onClick={toggleProfileOptions}>
              <img src={userData?.profile_pic ? `${baseurl}${userData.profile_pic.replace(/^\//, '')}` : '/assets/avatar.jpg'} alt="user profile" className="user-image" />
              
            </div>
            <div className="username-container">
              <span className="user-name common-text fts-15 ftw-4 white">
                {userData?.full_name || 'User Name'}
              </span>
              <span className="role common-text fts-13 ftw-4 white">
                {userData?.role?.name || 'User Role'}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Profile and Notification Popups */}
      <MyProfile isOpen={showProfileOptions} onClose={() => setShowProfileOptions(false)} />
      <NotificationPopup isOpen={showNotificationOptions} onClose={() => setShowNotificationOptions(false)} />
    </div>
  );
}

export default Navbar;


